import React from 'react';
import { validate } from 'react-email-validator';
import i18n from '../translations/config';

export const validateEmail = (
  email: string,
  t: (text: string) => string,
): string | null => {
  if (!email.includes('@')) {
    return t("Please include an '@' in the email address.");
  }
  if (!email.includes('.')) {
    return t("Please include a '.' in the email address.");
  }
  if (!validate(email)) {
    return t('Please enter a valid email address.');
  }
  return null;
};

export const handleEmailSubmit = (
  e: React.SyntheticEvent | React.ChangeEvent<HTMLInputElement>,
  email: string,
  t: (text: string) => string,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
): void => {
  if (!email) {
    e.preventDefault();
  } else {
    const errorMessage = validateEmail(email, t);
    if (errorMessage) {
      e.preventDefault();
      setError(errorMessage);
    } else {
      setError(null);
    }
  }
};

// TODO had to pin TS to version 4.2.2 explicitly otherwise SB breaks for a known issue:
// https://github.com/storybookjs/storybook/issues/15067
// So until someone fixes it I've pinned it to this working solution.
export const changeLanguage = (lang?: string): void => {
  i18n.changeLanguage(lang);
};
